<template>
  <b-card class="page-card buy-parts-page" no-body>
    <div class="buy-parts-hero">
      <div>
        <h2 class="mb-2">Buy Parts</h2>
        <p class="mb-0 text-muted">Search and order the parts your unit needs. Start with a quick workflow below.</p>
      </div>
      <font-awesome-icon icon="shopping-cart" class="buy-parts-hero-icon" />
    </div>

    <b-row class="mx-0 pb-4 px-3">
      <b-col md="6" class="mb-3 mb-md-0">
        <b-card class="h-100 workflow-card" body-class="d-flex flex-column">
          <h5 class="mb-2">Find Parts</h5>
          <p class="text-muted mb-3">Search by part number, keyword, or unit details.</p>
          <b-button variant="primary" class="mt-auto align-self-start" @click="searchNav">Start Search</b-button>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card class="h-100 workflow-card" body-class="d-flex flex-column">
          <h5 class="mb-2">Order History</h5>
          <p class="text-muted mb-3">View previously created parts orders and their status.</p>
          <b-button variant="outline-primary" class="mt-auto align-self-start" @click="orderHistoryNav">
            Open History
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'BuyPartsPage',
  methods: {
    searchNav() {
      this.$router.push('/search-parts');
    },
    orderHistoryNav() {
      this.$router.push('/order-history');
    }
  }
};
</script>

<style scoped>
.buy-parts-page {
  overflow: hidden;
}

.buy-parts-hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1rem;
  margin: 0.75rem;
  border-radius: 0.375rem;
  background: linear-gradient(135deg, #f6f8fb 0%, #eef3f8 100%);
  border: 1px solid #dbe5f0;
}

.buy-parts-hero-icon {
  font-size: 1.75rem;
  color: #3b556e;
}

.workflow-card {
  border: 1px solid #dbe5f0;
}
</style>
